import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-2xl font-medium text-gray-900" }
const _hoisted_2 = { class: "space-y-4" }
const _hoisted_3 = { class: "text-sm" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "text-red-500 mt-3" }
const _hoisted_6 = { class: "flex mt-3 text-sm text-brand-600 justify-end" }
const _hoisted_7 = { class: "mt-4" }

import axios from 'axios'

	import {
		getMultilinguals,
		getValueLists
	} from '../../../queries'

	import { 
		Auth
	} from '@/api/Auth'
	
	// language
	import {
		useI18n
	} from 'vue-i18n'

	// router
	import {
		useRouter,
		useRoute
	} from 'vue-router'

	// store
	import { 
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { 
		store as _valueListStore
	} from '@/store/valueLists'

	// types
	import { 
		LangTypes,
		ValueList
	} from '@/types'

	// vue
	import {
		inject,
		ref
	} from 'vue'

	interface ValueListValue {
		label: string
		value: string
	}

	
	const __default__ = { name: 'LoginForm' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// api
	const userStore = _userStore()
	const valueListStore = _valueListStore()
	const _localesStore = localesStore()

	const router = useRouter()
	const route = useRoute()

	const {t} = useI18n()

	const email = ref("")
	const password = ref("")
	const loginLoading = ref(false)
	const loginError = ref(false)
	const i18n = inject<any>('i18n')

	async function login() {
		loginLoading.value = true

		// check for empty field values
		if (email.value == "") {
			document.getElementById('email')?.focus()
			loginError.value = true
			loginLoading.value = false
			return
		}
		else if (password.value == "") {
			document.getElementById('password')?.focus()
			loginError.value = true
			loginLoading.value = false
			return
		}

		// configure session if not set
		if(localStorage.sessionId == undefined) {
			localStorage.sessionId = Math.random().toString(36).substring(2)
			const sessionId = localStorage.sessionId
			axios.defaults.headers.common['Session-Id'] = sessionId
		}
      
		// attempt login
		let response = await Auth.signIn(email.value, password.value)

		if (!response.authenticated) {
			loginError.value = true
			loginLoading.value = false
			return
		}

		userStore.user = response.user

		// update language
		if(userStore.user.language.includes('Kanji')) {
			i18n.global.locale.value = 'ja'
			_localesStore.locales.selected = 'ja' as LangTypes.ja
		}
		else if(userStore.user.language.includes('Kana')) {
			i18n.global.locale.value = 'kana'
			_localesStore.locales.selected = 'kana' as LangTypes.kana

		}
		else if(userStore.user.language.includes('English')) {
			i18n.global.locale.value = 'en'
			_localesStore.locales.selected = 'en' as LangTypes.en
		}

		try { // getting translations from filemaker	
			let res = await getMultilinguals()
			let vlRes = await getValueLists(userStore.user.contactId)

			vlRes.response.valueLists.forEach((list: ValueList) => {
				let lowerName = list.name.toLowerCase()
				let key = lowerName.split("_").reduce((s, c) => s + (c.charAt(0).toUpperCase() + c.slice(1)))
				const indexToRemove = list.values.findIndex(v => v.value === "-")
				if(indexToRemove > -1) list.values.splice(indexToRemove, 1)
				valueListStore.valueList[key] = list.values.map((option) => {					
					return {
						value: option.value,
						label: option.displayValue,
						checked: false
					}					
				})
			})

			_localesStore.locales.en = JSON.parse("{" + res.response.data[0].fieldData.zsJsonEn.replace(/\r/g, ',') + "}")
			_localesStore.locales.ja = JSON.parse("{" + res.response.data[0].fieldData.zsJsonKanji.replace(/\r/g, ',') + "}")
			_localesStore.locales.kana = JSON.parse("{" + res.response.data[0].fieldData.zsJsonKana.replace(/\r/g, ',') + "}")
		}
		catch(e) {
			console.error(e)
		}

		if (userStore.user?.isPasswordChangeNeeded) {
			loginLoading.value = false
			router.push({name:'UpdatePassword'})
		}
		else {			  
			loginLoading.value = false

			// handle redirects
			router.push(route?.query?.redirect ? String(route?.query?.redirect) : { name: 'Jobs' })
		}
	}
	// #endregion

	const showPassword = ref(false)

	function toggleShowPassword() {
		const passwordField = document.querySelector('#password')

		if(passwordField?.getAttribute('type') === 'password') {
			passwordField.setAttribute('type', 'text')
			showPassword.value = true
		}
		else{
			passwordField?.setAttribute('type', 'password')
			showPassword.value = false
		}
	}

return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_EyeIcon = _resolveComponent("EyeIcon")!
  const _component_EyeSlashIcon = _resolveComponent("EyeSlashIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('login.title')), 1)
    ]),
    _createElementVNode("form", {
      class: "mt-8",
      onSubmit: _withModifiers(login, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_tw_input, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
            id: "email",
            required: true,
            type: "email",
            label: _unref(t)('login.email'),
            validation: _unref(t)('login.emailValidation'),
            class: "text-md"
          }, null, 8, ["modelValue", "label", "validation"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_tw_input, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
            id: "password",
            required: true,
            type: "password",
            label: _unref(t)('login.password'),
            validation: _unref(t)('login.passwordValidation'),
            class: "text-md"
          }, {
            trailing_inline: _withCtx(() => [
              _createElementVNode("button", {
                type: "button",
                onClick: toggleShowPassword,
                class: "border-none bg-transparent hover:bg-transparent"
              }, [
                (!showPassword.value)
                  ? (_openBlock(), _createBlock(_component_EyeIcon, {
                      key: 0,
                      class: "h-5"
                    }))
                  : (_openBlock(), _createBlock(_component_EyeSlashIcon, {
                      key: 1,
                      class: "h-5"
                    }))
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "label", "validation"])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_unref(t)('login.invalidEmailPassword')), 1)
        ], 512), [
          [_vShow, loginError.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: {name: 'ResetPassword'},
          class: "link"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('login.forgotYourPassword')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_tw_button, {
          type: "submit",
          class: "btn-brand font-medium w-full",
          disabled: loginLoading.value,
          loading: loginLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('login.login')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ], 32)
  ], 64))
}
}

})